import React, {Fragment} from "react";
import isEqual from "lodash-es/isEqual";
import Portal from "../layout/Portal";
import Modal from "../layout/Modal";
import {postData} from "../../utils/request";
import {CurrencyFormatter} from "../../utils/formatters";
import Button from "../form/Button";

export class RoundingCorrectionButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            opened: false,
            amount: this.props.transaction.balance
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual(this.props.transaction.balance, prevProps.transaction.balance)) {
            this.setState({
                amount: this.props.transaction.balance
            });
        }
    }

    render() {
        return (
            <Fragment>
                <Portal>
                    <Modal
                        header="Kerekítéses kompenzáció"
                        size="small"
                        state={this.state.opened}
                        buttons={[
                            {
                                text: "Mégse",
                                props: {color: "default", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                onClose: true,
                                onClick: async () => {
                                    try {
                                        this.setState({opened: false});
                                    } catch (e) {

                                    }
                                }
                            },
                            {
                                text: "Kompenzálás",
                                props: {color: "primary", disabled: this.props.disabled || this.props.isLoading || this.state.isLoading},
                                onClick: async () => {
                                    try {
                                        this.setState({isLoading: true});
                                        await postData({
                                            action: 'RoundingCorrection.create',
                                            data: {
                                                transaction: this.props.transaction.id,
                                            }
                                        });
                                        this.props.callBack && this.props.callBack();
                                        this.setState({opened: false, isLoading: false});
                                    } catch (e) {
                                        console.error(e);
                                    }
                                }
                            }
                        ]}
                    >
                        <b>Biztos? {CurrencyFormatter(this.state.amount).props.children} kerekítés lesz hozzáadva!</b>
                    </Modal>
                </Portal>
                <Button
                    disabled={this.state.amount == 0}
                    icon={{lib: "fas", name: "receipt"}}
                    size="xs"
                    color="default"
                    tooltip="Kerekítéses kompenzáció"
                    onClick={(e) => {
                        e && e.preventDefault();
                        e && e.stopPropagation();
                        this.setState({opened: true});
                        return false;
                    }}
                />
            </Fragment>
        );
    }
}